import "./_hero-banner-styles.scss";

import './view';
